module.exports = __webpack_public_path__ + "img/iso_icon.6530a582.svg";